export default {
  common: {
    changePassword: "Change Password",
    logout: "Logout"
  }
};
